// extracted by css-extract-rspack-plugin
export default {"row":"kpCwb","icon":"Cvym2","clickableName":"BMRYf","name":"n7oFr","handle":"DC2UW","expandIndicator":"DX4Kt"};